import type { RouteObject } from 'react-router-dom'

import ForgotPassword from 'pages/ForgotPassword'
import MarketGate from 'components/MarketGate'
import Layout from 'components/Layout/Layout'
import Account from 'pages/Account'
import SignIn from 'pages/SignIn'
import Logs from 'pages/Logs'

import UserForm from 'pages/Users/Form'
import Users from 'pages/Users'

import PrizeEditForm from 'pages/PrizesGroups/EditForm/PrizeEditForm'
import PrizeAddForm from 'pages/PrizesGroups/AddForm/PrizeAddForm'
import ChangeUserDataForm from 'pages/ChangeUserDataForm'
import Prizes from 'pages/PrizesGroups/Prizes'
import PrizesGroups from 'pages/PrizesGroups'

import MarketEditForm from 'pages/Markets/Form/MarketEditForm'
import MarketAddForm from 'pages/Markets/Form/MarketAddForm'
import Markets from 'pages/Markets'
import FormBuilder from 'pages/Markets/FormBuilder'

import ApplicationDetails from 'pages/Applications/Details/ApplicationDetails'
import ApplicationEditForm from 'pages/Applications/Form/ApplicationEditForm'
import ApplicationAddForm from 'pages/Applications/Form/ApplicationAddForm'
import Applications from 'pages/Applications'

import GlobalBarcodesForm from 'pages/Barcodes/GlobalBarcodesForm'
import BarcodesForm from 'pages/Barcodes/Form/BarcodesForm'
import BarcodesTabs from 'pages/Barcodes/BarcodesTabs'
import BarcodeFailChecks from 'pages/Barcodes/BarcodeFailChecks'

import MarketLanguages from 'pages/MarketLanguages'

import Translations from 'pages/Translations'

import { WinnersNotifications } from 'pages/ImportPrizes/winners-notifications'
import { PrizesTracker } from 'pages/ImportPrizes/prizes-tracker'
import { EmbargoTracker } from 'pages/ImportPrizes/embargo-tracker'

import type { ApplicationFormProps } from 'pages/Applications/Form/ApplicationForm.types'
import ImportPrizesAndApplications from '../pages/ImportPrizesAndApplications'
import { Trans } from 'react-i18next'
import { Paper } from '@mui/material'
import { DashboardWrapper } from 'pages/Dashboard/dashboard-wrapper'

export const routerOptions: RouteObject[] = [
  {
    path: '/',
    element: <SignIn />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  /**
   * 
         <Layout title={<Trans i18nKey='navigation.importPrizes' />}>
           <Paper sx={{ p: 2 }}>
             <MarketGate
               key='translations'
               onlyFlow='pd'
               componentProps={{}}
               Component={WinnersNotifications}
               titleTranslationCode='winnersNotifications.title'
             />
           </Paper>
         </Layout>
   */
  {
    path: '/dashboard',
    element: (
      <Layout title={<Trans i18nKey="navigation.dashboard" />}>
        <DashboardWrapper />
      </Layout>
    ),
  },
  // {
  //   path: '/dashboard-2',
  //   element: (
  //     <Layout title={<Trans i18nKey="navigation.dashboard" />}>
  //       <DashboardWrapper second />
  //     </Layout>
  //   ),
  // },
  {
    path: '/account',
    element: (
      <Layout>
        <Account />
      </Layout>
    ),
  },
  {
    path: '/logs',
    element: (
      <Layout>
        <Logs />
      </Layout>
    ),
  },
  {
    path: '/market-languages',
    element: (
      <Layout>
        <MarketLanguages />
      </Layout>
    ),
  },
  {
    path: '/change-account-data/:field',
    element: (
      <Layout>
        <ChangeUserDataForm />
      </Layout>
    ),
  },
  {
    path: '/translations',
    element: (
      <Layout>
        <MarketGate
          key="translations"
          componentProps={{}}
          Component={Translations}
          titleTranslationCode="navigation.translations"
        />
      </Layout>
    ),
  },
  {
    path: '/users',
    element: (
      <Layout>
        <Users />
      </Layout>
    ),
  },
  {
    path: '/users/edit/:id',
    element: (
      <Layout>
        <UserForm type="edit" />
      </Layout>
    ),
  },
  {
    path: '/users/add',
    element: (
      <Layout>
        <UserForm type="add" />
      </Layout>
    ),
  },
  {
    path: '/markets',
    element: (
      <Layout>
        <Markets />
      </Layout>
    ),
  },
  {
    path: '/markets/edit/:id',
    element: (
      <Layout>
        <MarketEditForm />
      </Layout>
    ),
  },
  {
    path: '/markets/add',
    element: (
      <Layout>
        <MarketAddForm />
      </Layout>
    ),
  },
  {
    path: '/markets/:id/form-builder',
    element: (
      <Layout>
        <FormBuilder />
      </Layout>
    ),
  },
  {
    path: '/markets',
    element: (
      <Layout>
        <Markets />
      </Layout>
    ),
  },
  {
    path: '/prizes-groups',
    element: (
      <Layout title={<Trans i18nKey="prize.groups" />}>
        <Paper sx={{ p: 4 }}>
          <MarketGate
            key="translations"
            allOption
            componentProps={{}}
            Component={PrizesGroups}
            titleTranslationCode="prize.title"
            descriptionCode="prize.description"
          />
        </Paper>
      </Layout>
    ),
  },
  {
    path: '/prizes',
    element: (
      <Layout>
        <Prizes />
      </Layout>
    ),
  },
  {
    path: '/prizes/add',
    element: (
      <Layout>
        <PrizeAddForm />
      </Layout>
    ),
  },
  {
    path: '/prizes/edit/:id',
    element: (
      <Layout>
        <PrizeEditForm />
      </Layout>
    ),
  },
  {
    path: '/barcodes',
    element: (
      <Layout>
        <BarcodesTabs />
      </Layout>
    ),
  },
  {
    path: '/barcodes/add',
    element: (
      <Layout>
        <BarcodesForm />
      </Layout>
    ),
  },
  {
    path: '/barcodes/fail-checks',
    element: (
      <Layout>
        <BarcodeFailChecks />
      </Layout>
    ),
  },
  {
    path: '/global-barcodes/add',
    element: (
      <Layout>
        <GlobalBarcodesForm />
      </Layout>
    ),
  },
  {
    path: '/applications',
    element: (
      <Layout>
        <Applications />
      </Layout>
    ),
  },
  {
    path: '/applications/:id',
    element: (
      <Layout
        title={<Trans i18nKey="navigation.applications" />}
        description={<Trans i18nKey="common.trackApplication" />}
      >
        <ApplicationDetails />
      </Layout>
    ),
  },
  {
    path: '/applications/add',
    element: (
      <Layout>
        <MarketGate<ApplicationFormProps>
          key="translations"
          componentProps={{ type: 'add', selectedMarketId: '' }}
          Component={ApplicationAddForm}
          titleTranslationCode="navigation.addApplication"
        />
      </Layout>
    ),
  },
  {
    path: '/applications/edit/:id',
    element: (
      <Layout>
        <ApplicationEditForm type="edit" selectedMarketId="" />
      </Layout>
    ),
  },
  {
    path: '/winners-notifications',
    element: (
      <Layout
        title={<Trans i18nKey="navigation.importPrizes" />}
        description={<Trans i18nKey="winnersNotifications.description" />}
      >
        <Paper sx={{ p: 4 }}>
          <MarketGate
            key="translations"
            onlyFlow="pd"
            componentProps={{}}
            Component={WinnersNotifications}
            titleTranslationCode="winnersNotifications.title"
          />
        </Paper>
      </Layout>
    ),
  },
  {
    path: '/prizes-tracker',
    element: (
      <Layout title={<Trans i18nKey="navigation.adminWinners" />}>
        <Paper sx={{ p: 4 }}>
          <MarketGate
            key="prizes-management"
            componentProps={{}}
            customFilter={market => market.flow === 'pd' && !!market.pdRequest}
            Component={PrizesTracker}
            titleTranslationCode="prizesManagement.title"
          />
        </Paper>
      </Layout>
    ),
  },
  {
    path: '/embargo-tracker',
    element: (
      <Layout title={<Trans i18nKey="navigation.embargoTracker" />}>
        <Paper sx={{ p: 4 }}>
          <MarketGate
            key="embargo-tracker"
            componentProps={{}}
            Component={EmbargoTracker}
            titleTranslationCode="embargoTracker.title"
          />
        </Paper>
      </Layout>
    ),
  },
  {
    path: '/winners-notifications-applications',
    element: (
      <Layout>
        <MarketGate
          key="winners-notifications-applications"
          componentProps={{}}
          Component={ImportPrizesAndApplications}
          titleTranslationCode="navigation.importPrizesApplications"
        />
      </Layout>
    ),
  },
]
